import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { DotLottie } from "@lottiefiles/dotlottie-web";

// import { SplitText } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(SplitText)
// console.log("animations.js loaded ");

console.log("animations.js is loaded");
/**
 * solutions snake lines
 *
 */
const svgLines = document.querySelectorAll("#solutions svg .change line");
// console.log("there are ", svgLines.length, "paths");
if (svgLines && svgLines.length > 0) {
  gsap.fromTo(
    svgLines,
    { stroke: "#D9D9D9" },
    {
      // stroke: "#0A79EC",
      scrollTrigger: {
        trigger: "#solutions",
        start: "top 75%",
        end: "bottom 75%",
        scrub: true,
        onUpdate: (self) => {
          // Calculate the progress percentage (0 to 1)
          const progress = self.progress;
          // Update each line's stroke based on the current progress
          svgLines.forEach((line, i) => {
            if (i / svgLines.length < progress) {
              line.style.stroke = "#0A79EC";
            } else {
              line.style.stroke = "#D9D9D9";
            }
          });
        },
      },
    }
  );
}
/**
 * solutions snake images
 */
const revealImages = document.querySelectorAll("svg.image-reveal");
revealImages.forEach((maskdiv, i) => {
  const mask = maskdiv.querySelector("mask rect");
  const img = maskdiv.querySelector("foreignObject");
  if (i % 2 === 0) {
    gsap.to(mask, {
      x: 0,
      width: 880,
      scrollTrigger: {
        trigger: mask,
        start: "top 75%", // Adjust start and end positions as needed
        end: "bottom 25%",
        scrub: false,
      },
    });
  } else {
    gsap.fromTo(
      mask,
      { attr: { width: 0, x: 880 } }, // Start at width 0, x positioned on the right
      {
        attr: { width: 880, x: 0 }, // Move to align with left edge
        scrollTrigger: {
          trigger: mask,
          start: "top 75%", // Adjust start and end positions as needed
          end: "bottom 25%",
          scrub: false,
        },
      }
    );
  }
});

/**
 * CTA Banner Spinning Circle
 */
const ctaSVG = document.querySelectorAll("svg#cta-svg");
ctaSVG.forEach((cta, i) => {
  const lg = cta.querySelector("g.cta-lines");
  gsap.to(cta, {
    rotate: 135, // Full rotation
    scrollTrigger: {
      trigger: cta,
      delay: 0.5,
      //   ease: "bounce.out",
      start: "top bottom",
      end: "bottom 50%",
      scrub: true,
    },
  });
});

/**
 * Team Footer Marquee
 */
const teamFooter = document.querySelector("#team-footer");
document.addEventListener("DOMContentLoaded", () => {
  if (teamFooter) {
    let speed = window.innerWidth > 1024 ? 1.5 : 1.25;
    // const ul = teamFooter.querySelectorAll("ul");
    // const clonedNode = ul.cloneNode(true);
    // for (let i = 0; i < clonedNode.children.length; i++) {
    //   clonedNode.children[i].classList.add("cloned");
    //   ul.appendChild(clonedNode.children[i]);
    // }
    const links = teamFooter.querySelectorAll("li");
    const tl = horizontalLoop(links, {
      repeat: -1,
      speed: speed,
      draggable: true,
      reversed: false,
      paddingRight: parseFloat(gsap.getProperty(links[0], "marginRight", "px")),
    });

    links.forEach((link) => {
      link.addEventListener("mouseenter", () =>
        gsap.to(tl, { timeScale: 0, overwrite: true })
      );
      link.addEventListener("mouseleave", () =>
        gsap.to(tl, { timeScale: 1, overwrite: true })
      );
    });

    // Intersection Observer to control the timeline
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            tl.play(); // Play when the element is onscreen
          } else {
            tl.pause(); // Pause when the element is offscreen
          }
        });
      },
      { threshold: 0.1 } // Trigger when at least 10% of the element is visible
    );

    // Start observing the teamFooter element
    observer.observe(teamFooter);

    // change speed on resize
    window.addEventListener("resize", () => {
      speed = window.innerWidth > 1024 ? 1.5 : 1.25;
    });
  }
});
/**
 *
 * Locations List Lottie Animation
 */
//const loclottie = new DotLottiePlayer('#locations_list_lottie');
const locations_list = document.querySelector("section#locations_list");
if (locations_list) {
  const sources = [];
  const list = locations_list.querySelectorAll("ul li");
  list.forEach((element, i) => {
    sources.push(element.dataset.asset);
  });

  // console.log(sources);
  const dotLottie = new DotLottie({
    autoplay: true,
    loop: true,
    canvas: document.querySelector("#locations_list_lottie"),
    src: sources[0], // or .json file
  });
  // do something here on load
  dotLottie.addEventListener("load", function () {
    console.log("list locations dot lottie laoded");
    const lineContainers2 = document.querySelectorAll(".line-container");
    function setLineContainerHeights2() {
      console.log("setting line container height animations.js");
  
      lineContainers2.forEach((lineContainer) => {
        if (window.innerWidth < 1024) {
          lineContainer.style.height = `auto`;
        } else {
          let innerHeight = lineContainer.querySelector(".relative").offsetHeight;
          lineContainer.style.height = `${
            innerHeight + (14 - (innerHeight % 14))
          }px`;
        }
      });
    }
    setLineContainerHeights2();
  });

  list.forEach((element, i) => {
    element.addEventListener("click", (e) => {
      document.querySelector("#locations_list_lottie").style.transform =
        "translateY(100%)";

      list.forEach((li) => {
        li.classList.remove("active");
      });
      element.classList.add("active");
      // console.log(e.target.dataset.asset);
      dotLottie.stop();
      setTimeout(() => {
        dotLottie.load({
          autoplay: true,
          loop: true,
          canvas: document.querySelector("#locations_list_lottie"),
          src: sources[i],
        });
        dotLottie.resize();
        dotLottie.setFrame(0);
      }, 250);
      setTimeout(() => {
        document.querySelector("#locations_list_lottie").style.transform =
          "translateY(0)";
        // dotLottie.play();
      }, 750);

      //document.querySelector("#locations_list_lottie").parentNode.style.transform = 'scale(1)';
    });
  });
}

/**
 * Strategic Gateways Animation toggles
 */
const strategicGatewaysAnimation =
  document.getElementById("strategic-gateways");
if (strategicGatewaysAnimation) {
  const dotLottie = new DotLottie({
    autoplay: true,
    loop: false,
    canvas: document.querySelector("#player-05"),
    src: "/wp-content/themes/frontier/public/lottie/info_05.1.lottie",
  });
  dotLottie.resize();

  window.addEventListener("resize", function () {
    dotLottie.resize();
  });

  // event listeners here
  document
    .querySelector("#strategic-gateways .btn.wilmington")
    .addEventListener("click", (e) => {
      document
        .querySelector("#strategic-gateways .btn.shannon")
        .classList.remove("active");
      document
        .querySelector("#strategic-gateways .btn.wilmington")
        .classList.add("active");
      document
        .querySelector("#strategic-gateways .content .shannon")
        .classList.add("hidden");
      document
        .querySelector("#strategic-gateways .content .wilmington")
        .classList.remove("hidden");
      dotLottie.load({
        autoplay: true,
        loop: false,
        canvas: document.querySelector("#player-05"),
        src: "/wp-content/themes/frontier/public/lottie/info_05.3.lottie",
      });
      dotLottie.resize();
    });
  document
    .querySelector("#strategic-gateways .btn.shannon")
    .addEventListener("click", (e) => {
      document
        .querySelector("#strategic-gateways .btn.wilmington")
        .classList.remove("active");
      document
        .querySelector("#strategic-gateways .btn.shannon")
        .classList.add("active");
      document
        .querySelector("#strategic-gateways .content .wilmington")
        .classList.add("hidden");
      document
        .querySelector("#strategic-gateways .content .shannon")
        .classList.remove("hidden");
      dotLottie.load({
        autoplay: true,
        loop: false,
        canvas: document.querySelector("#player-05"),
        src: "/wp-content/themes/frontier/public/lottie/info_05.2.lottie",
      });
      dotLottie.resize();
    });
}

function horizontalLoop(items, config) {
  items = gsap.utils.toArray(items);
  config = config || {};
  let tl = gsap.timeline({
      repeat: config.repeat,
      paused: config.paused,
      defaults: { ease: "none" },
      onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100),
    }),
    length = items.length,
    startX = items[0].offsetLeft,
    times = [],
    widths = [],
    xPercents = [],
    curIndex = 0,
    pixelsPerSecond = (config.speed || 1) * 100,
    snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
    populateWidths = () =>
      items.forEach((el, i) => {
        widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
        xPercents[i] = snap(
          (parseFloat(gsap.getProperty(el, "x", "px")) / widths[i]) * 100 +
            gsap.getProperty(el, "xPercent")
        );
      }),
    getTotalWidth = () =>
      items[length - 1].offsetLeft +
      (xPercents[length - 1] / 100) * widths[length - 1] -
      startX +
      items[length - 1].offsetWidth *
        gsap.getProperty(items[length - 1], "scaleX") +
      (parseFloat(config.paddingRight) || 0),
    totalWidth,
    curX,
    distanceToStart,
    distanceToLoop,
    item,
    i;
  populateWidths();
  gsap.set(items, {
    // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
    xPercent: (i) => xPercents[i],
  });
  gsap.set(items, { x: 0 });
  totalWidth = getTotalWidth();
  for (i = 0; i < length; i++) {
    item = items[i];
    curX = (xPercents[i] / 100) * widths[i];
    distanceToStart = item.offsetLeft + curX - startX;
    distanceToLoop =
      distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
    tl.to(
      item,
      {
        xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
        duration: distanceToLoop / pixelsPerSecond,
      },
      0
    )
      .fromTo(
        item,
        {
          xPercent: snap(
            ((curX - distanceToLoop + totalWidth) / widths[i]) * 100
          ),
        },
        {
          xPercent: xPercents[i],
          duration:
            (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
          immediateRender: false,
        },
        distanceToLoop / pixelsPerSecond
      )
      .add("label" + i, distanceToStart / pixelsPerSecond);
    times[i] = distanceToStart / pixelsPerSecond;
  }
  function toIndex(index, vars) {
    vars = vars || {};
    Math.abs(index - curIndex) > length / 2 &&
      (index += index > curIndex ? -length : length); // always go in the shortest direction
    let newIndex = gsap.utils.wrap(0, length, index),
      time = times[newIndex];
    if (time > tl.time() !== index > curIndex) {
      // if we're wrapping the timeline's playhead, make the proper adjustments
      vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
      time += tl.duration() * (index > curIndex ? 1 : -1);
    }
    curIndex = newIndex;
    vars.overwrite = true;
    return tl.tweenTo(time, vars);
  }
  tl.next = (vars) => toIndex(curIndex + 1, vars);
  tl.previous = (vars) => toIndex(curIndex - 1, vars);
  tl.current = () => curIndex;
  tl.toIndex = (index, vars) => toIndex(index, vars);
  tl.updateIndex = () =>
    (curIndex = Math.round(tl.progress() * (items.length - 1)));
  tl.times = times;
  tl.progress(1, true).progress(0, true); // pre-render for performance
  if (config.reversed) {
    tl.vars.onReverseComplete();
    tl.reverse();
  }
  if (config.draggable && typeof Draggable === "function") {
    let proxy = document.createElement("div"),
      wrap = gsap.utils.wrap(0, 1),
      ratio,
      startProgress,
      draggable,
      dragSnap,
      roundFactor,
      align = () =>
        tl.progress(
          wrap(startProgress + (draggable.startX - draggable.x) * ratio)
        ),
      syncIndex = () => tl.updateIndex();
    typeof InertiaPlugin === "undefined" &&
      console.warn(
        "InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club"
      );
    draggable = Draggable.create(proxy, {
      trigger: items[0].parentNode,
      type: "x",
      onPress() {
        startProgress = tl.progress();
        tl.progress(0);
        populateWidths();
        totalWidth = getTotalWidth();
        ratio = 1 / totalWidth;
        dragSnap = totalWidth / items.length;
        roundFactor = Math.pow(
          10,
          ((dragSnap + "").split(".")[1] || "").length
        );
        tl.progress(startProgress);
      },
      onDrag: align,
      onThrowUpdate: align,
      inertia: true,
      snap: (value) => {
        let n =
          Math.round(parseFloat(value) / dragSnap) * dragSnap * roundFactor;
        return (n - (n % 1)) / roundFactor;
      },
      onRelease: syncIndex,
      onThrowComplete: () => gsap.set(proxy, { x: 0 }) && syncIndex(),
    })[0];
  }

  return tl;
}
